export default "__VITE_ASSET__BO08KbRb__"